"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        button: {
            position: 'absolute',
            right: spacing(2),
            top: spacing(2),
            color: palette.grey[600],
            cursor: 'pointer',
            zIndex: 100,
            '&:hover': {
                color: palette.grey[500]
            }
        }
    });
});
exports.default = useStyles;
